import React, { useState, useEffect, useRef } from "react";
import classes from "./chat.module.css";
// import Loader from "../../RFQ/Body/Loader";
import { currentRequestTimeStamp } from "../../../Constants";
// import mixpanel from "mixpanel-browser";
import { Urls } from "../../../Urls";
import Axios from "../../../Axios";
import { toast } from "react-toastify";
// import { useAppContext } from "../../../Context/AppContext";
import { getChats } from "../../../Utility";
import { decryptResponse } from "../../RateCard/utils";
import { useMixPanelForTracking } from "../../../shared_utilities/trackMixPanel";

const AuctionChat = ({
  transporter_id,
  transporter_name,
  auction_id,
  fulldata,
  buttonClassName,
  // connection_msg = [],
  auctionClosedStatus,
}) => {
  // const { transporterInfo } = useAppContext();
  const [message, setmessage] = useState("");
  const [msgList, setMsgList] = useState([]);
  const {TrackMixPanel} = useMixPanelForTracking()
  // const [show, setShow] = useState(false);
  // const [readStatus, setReadStatus] = useState([]);
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current && messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(()=>{
    scrollToBottom()
  },[msgList])

  useEffect(() => {
    
    // Call the function to fetch available chat options or data
    getavailablechat();
    // Call the getChats function to fetch and set chat messages
    // Pass the auction_id and setMsgList function to getChats
    getChats(auction_id, setMsgList,buttonClassName,transporter_id,transporter_name);
    scrollToBottom()
    
    // The empty dependency array means this effect runs once on component mount
}, []); // Dependency array


  // useEffect(() => {
    // getChats(auction_id,setMsgList)
    // if (
    //   connection_msg &&
    //   connection_msg.message_list &&
    //   connection_msg.message_list.length > 0
    // ) {
    //   var company_chat_message = connection_msg.message_list.filter(
    //     (transporter) =>
    //       transporter.transporter_id === transporterInfo.transporter_id
    //   );
    //   var updated = false;
    //   if (company_chat_message.length > 0) {
    //     var new_msgList = msgList.slice();
    //     if (
    //       msgList.filter(
    //         (transporter) =>
    //           transporterInfo.transporter_id === transporter.transporter_id
    //       ).length > 0
    //     ) {
    //       msgList.map((transporter, index) => {
    //         if (transporter.transporter_id === transporterInfo.transporter_id) {
    //           updated = true;
    //           transporter.messages.push(company_chat_message[0].messages[0]);
    //         }
    //         return transporter;
    //       });
    //     } else {
    //       new_msgList.push(company_chat_message[0]);
    //     }

    //     // setMsgList(new_msgList);
    //     // setReadStatus(new_msgList.messages)
    //   }
    // }

    // setMsgList(connection_msg)
  // }, []);

  /**
 * Fetches available chat data from the server and updates the message list.
 * @param {string} auction_id - The ID of the auction for which to fetch chat data.
 * @param {string} transporter_id - The ID of the transporter associated with the chat.
 * @param {Function} setMsgList - Function to update the state with the fetched chat messages.
 * @returns {void}
 */
const getavailablechat = () => {
  // setShow(true);
  
  // Perform a GET request to fetch chat data
  Axios.get(
    `${Urls.auction}?chat=true&auction_id=${auction_id}&transporter_id=${transporter_id}`
  )
    .then((response) => {
      // setShow(false);
      
      // Decrypt the response data
      const res = {data: decryptResponse(response.data)};
      
      // Check if decrypted data exists and has elements
      if (res.data && res.data.length > 0) {
        // Update the message list with the fetched data
        setMsgList(res.data);
      } else {
        // Update the message list to be empty if no data is found
        setMsgList([]);
      }
      getChats(auction_id, setMsgList,buttonClassName,transporter_id,transporter_name);
    })
    .catch((e) => {
      // setShow(false);
      
      // Log any errors that occur during the request
      console.log(e);
    });
};


  /**
 * Converts a date input into a formatted string representing the date and time.
 * @param {string | Date} dateinput - The date to convert, which can be a string or a Date object.
 * @returns {string} The formatted date and time string in the format "Month dd, yyyy hh:mm".
 */
const date_conversion_enquiry = (dateinput) => {
  // Create a Date object from the input date
  var date_considered = new Date(dateinput);
  
  // Extract day, month, year, hours, and minutes from the Date object
  var dd = date_considered.getDate();
  var mm = date_considered.getMonth() + 1; // Months are zero-based, so add 1
  var yyyy = date_considered.getFullYear();
  var hours = date_considered.getHours();
  var minutes = date_considered.getMinutes();
  
  // Array to map month numbers to month names
  var month_name = [];
  month_name[1] = "Jan";
  month_name[2] = "Feb";
  month_name[3] = "Mar";
  month_name[4] = "Apr";
  month_name[5] = "May";
  month_name[6] = "Jun";
  month_name[7] = "Jul";
  month_name[8] = "Aug";
  month_name[9] = "Sep";
  month_name[10] = "Oct";
  month_name[11] = "Nov";
  month_name[12] = "Dec";
  
  // Get the name of the month based on the month number
  var name_month = month_name[mm];
  
  // Pad single-digit day, month, hours, and minutes with leading zeroes
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  
  // Format the date and time into a string
  date_considered = `${name_month}${" "}${dd}, ${yyyy}${" "}${hours}:${minutes}`;
  
  // Return the formatted date and time string
  return date_considered;
};


  /**
 * Sends a message and updates the auction status if applicable.
 * This function sends the message to the server and updates the auction details
 * based on the current status of the auction.
 * @returns {void}
 */

const sendMessage = () => {
  // Activity([{ "screen": "Truck Availability", "module": "View Message" , "user_activity": `Send message button clicked`, "timestamp": currentRequestTimeStamp() }])
  // if(message !== null && message !== ''){
    //     setShow(true)
    //     var mssg = messagelist.slice()
  //     mssg.push({
  //       'value': message,
  //       "read_status":false,
  //       'user_type': 'company_user',
  //       'timestamp': currentRequestTimeStamp()
  //     });

  // Check if the auction is not closed
  if (!auctionClosedStatus) {
      // Initialize a new message list
      var mssg = [];
      var new_message = {
          value: message,
          read_status: false,
          user_type: "transporter",
          timestamp: currentRequestTimeStamp(),
      };
      
      // Map through the existing message list to add the new message
      mssg.map((m) => {
          m.message_list = [new_message];
      });

      // Send the message to the server
      Axios.post(`${Urls.messages}/messages`, {
          auction_id: auction_id,
          action: "chat",
          message_list: [
              {
                  transporter_id: transporter_id,
                  transporter_name: transporter_name,
                  messages: [
                      {
                          value: message,
                          read_status: false,
                          user_type: "transporter",
                          timestamp: currentRequestTimeStamp(),
                      },
                  ],
              },
          ],
      })
      .then((res) => {
          // setShow(false);
          TrackMixPanel({
            Data:{
              "AuctionId":auction_id,
              "AuctionDescription":fulldata?.auction_description,
              "ProcurementName":fulldata?.procurement_name,
              "Message":message
            },
            Definition:"user has sent a message to the client.",
            ModuleName:"tpmp auction",
            ScreenName:"auctions - active auctions - bidding screen - chat"
          })
          // Clear the message input field
          setmessage('');
          document.getElementById('message').value = '';
          // Display a success message
          toast.success("Message has been sent");
          getChats(auction_id, setMsgList,buttonClassName,transporter_id,transporter_name);
      })
      .catch((e) => console.log(e));
      
      // Update the auction status to indicate the message was read
      Axios.put(`${Urls.auction}`, {
          auction_id: auction_id,
          transporter_id: transporter_id,
          transporter_name: transporter_name,
          read_status: true,
      })
      .then((res) => {
          // Clear the message input field
          setmessage('');
          document.getElementById('message').value = '';
          getChats(auction_id, setMsgList,buttonClassName,transporter_id,transporter_name);
      })
      .catch((err) => {
          console.log(err);
      });
  }
};

useEffect(()=>{
  TrackMixPanel({
    Definition:"user has clicked on the chat button.",
    Data:{
      "AuctionId":auction_id,
      "AuctionDescription":fulldata?.auction_description,
      "ProcurementName":fulldata?.procurement_name,
      "Type":fulldata?.type || "reverse"
    },
    ModuleName:"tpmp auction",
    ScreenName:"auctions - active auctions - bidding screen"
  })
},[])


  return (
    <div>
      {/* <Loader show = {show}/> */}
      <div>
        <div className={`${classes["tr-chat"]}`}>
          <div className={classes["s-chat"]}>
            {msgList && msgList.length > 0 ? msgList.map((transporters) => {
              var messages = transporters.messages.map((msg) => {
                return (
                  <div
                    ref={messagesEndRef}
                    className={
                      msg.user_type && msg.user_type === "transporter"
                        ? classes["s-chat-list"]
                        : classes["s-chat-list-left"]
                    }
                  >
                    <span>
                      {msg.value.split("\n").map((text) => {
                        return (
                          <p
                            style={{
                              textAlign: "left",
                              margin: "0",
                              padding: "0 4px",
                              wordWrap: "break-word",
                            }}
                          >
                            {text}
                          </p>
                        );
                      })}
                    </span>
                    <span className={`${classes["date"]}`}>
                      {date_conversion_enquiry(msg.timestamp)}
                    </span>
                    <div ref={messagesEndRef} />
                  </div>
                );
              });
              return (
                <div>
                  {messages && messages.length > 0 ? messages : "No Messages"}
                </div>
              );
            }): (
            <div className={`d-flex justify-content-center align-items-center h-100`}>
              <h4>No Chat History Found</h4>
            </div>
            )}
          </div>
          {fulldata.auction_status !== "closed" ? (
            <div className={classes["s-div-inputs"]}>
              <div
                className="form-group"
                style={{ display: "flex", marginTop: "1%" }}
              >
                <textarea
                  type="text"
                  maxlength="1500"
                  className={`${classes["s-message"]}`}
                  placeholder="Type a message..."
                  id="message"
                  onChange={(event) => {
                    setmessage(event.target.value);
                  }}
                  rows="2"
                  cols="50"
                />
                <button
                  onClick={(e) => sendMessage(e)}
                  className={`${classes["s-sent-disabled"]}`}
                  disabled={message !== "" && message !== null && fulldata.auction_status !== "closed" ? false : true}
                >
                  <i className="fa fa-paper-plane" />
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AuctionChat;
